/**
 * 登录页（v0.47）。
 *
 * ★ 它是**唯一**在未登录时能看到的界面 —— 后端中间件放行的公开路由只有
 *   `/api/health`、`/api/auth/login|logout|me`，加上前端静态资源本身。
 *   静态资源必须公开，否则登录页自己都加载不出来（白屏 = 看起来服务挂了）。
 *
 * ⚠️ 这里**不做任何"记住我"**：会话本身已经是 14 天滑动续期，
 *    再叠一层"记住用户名"只会多一份 localStorage 状态要同步。
 */
import { useEffect, useRef, useState } from 'react';
import { login } from '../api/client';
import { useAuthStore } from '../store/auth';

export function LoginPage() {
  const setUser = useAuthStore((s) => s.setUser);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState<string | null>(null);
  const userRef = useRef<HTMLInputElement>(null);

  useEffect(() => { userRef.current?.focus(); }, []);

  const submit = async (e?: React.FormEvent) => {
    e?.preventDefault();
    if (busy) return;
    if (!username.trim() || !password) {
      setErr('请输入用户名与密码');
      return;
    }
    setBusy(true);
    setErr(null);
    try {
      const res = await login(username.trim(), password);
      setPassword('');
      setUser(res.user);
    } catch (e: any) {
      setErr(e?.message || '登录失败');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="login-page">
      <form className="login-card" onSubmit={submit}>
        <div className="login-brand">
          <span className="logo">◎</span>
          <div>
            <div className="brand-name">GDT Balloon AI Web</div>
            <div className="brand-sub">智能 FAI / 检验工程助手</div>
          </div>
        </div>

        <label className="login-field">
          <span>用户名</span>
          <input ref={userRef} className="login-input" type="text"
                 autoComplete="username" value={username}
                 onChange={(e) => setUsername(e.target.value)} />
        </label>

        <label className="login-field">
          <span>密码</span>
          <input className="login-input" type="password"
                 autoComplete="current-password" value={password}
                 onChange={(e) => setPassword(e.target.value)} />
        </label>

        {err && <div className="login-err">{err}</div>}

        <button className="btn primary login-submit" type="submit" disabled={busy}>
          {busy ? '登录中…' : '登 录'}
        </button>

        <div className="login-hint">
          首次使用请找<b>管理员</b>开号。
          <br />管理员账号见服务端生成的《初始管理员凭据.txt》。
        </div>
      </form>
    </div>
  );
}
